module.exports = __webpack_public_path__ + "img/12_klio_18.45256d7e.jpg";